import styled from "styled-components";
import Done from './../../../../assets/done-icon.png'
import Overdue from './../../../../assets/overdue-icon.png'
import Scheduled from './../../../../assets/scheduled-icon.png'


export const Icon = styled.div`
  width: 30px;
  height: 30px;
  background-image: url(${props => stageIcon(props.stage, props.showInCalendarAsScheduledInGreen, props.showInCalendarAsInProgressInGreen)});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
`;

export const TitleText = styled.div`
  margin-top: -5;
  font-size: '1rem';
  color: ${props => stageColor(props.stage, props.showInCalendarAsScheduledInGreen, props.showInCalendarAsInProgressInGreen)};
`;

const stageIcon = (stage, showInCalendarAsScheduledInGreen, showInCalendarAsInProgressInGreen) => {
  if(stage === 'scheduled' && showInCalendarAsScheduledInGreen) {
    return Done;
  }
  if(stage === 'scheduled' && !showInCalendarAsScheduledInGreen) {
    return Scheduled;
  }

  if(stage === 'progress' && showInCalendarAsInProgressInGreen) {
    return Done;
  }
  if(stage === 'progress' && !showInCalendarAsInProgressInGreen) {
    return Scheduled;
  }

  switch(stage) {
    case 'done':
      return Done;
    case 'overdue':
      return Overdue;
    case 'pending':
      return Overdue;
    case 'expired':
      return Overdue;
    default:
      return Scheduled;
  }
}

const stageColor = (stage, showInCalendarAsScheduledInGreen, showInCalendarAsInProgressInGreen) => {
  if(stage === 'scheduled' && showInCalendarAsScheduledInGreen) {
    return '#008000';
  }
  if(stage === 'scheduled' && !showInCalendarAsScheduledInGreen) {
    return '#457CDA';
  }

  if(stage === 'progress' && showInCalendarAsInProgressInGreen) {
    return '#008000';
  }
  if(stage === 'progress' && !showInCalendarAsInProgressInGreen) {
    return '#457CDA';
  }

  switch(stage) {
    case 'done':
      return '#008000';
    case 'overdue':
      return '#FA7D7D';
    case 'pending':
      return '#FA7D7D';
    case 'expired':
      return '#FA7D7D';
    default:
      return '#457CDA';
  }
}
